import { ImageComponent, toPlaceholderImage } from '@frontend/internal-assets';
import type { ImageAssetProps } from '@frontend/internal-assets';
import optimizedImage from './image-assets/practice-analytics.webp';

const thumbHashString = '8+eFCoI6uDZ+cHBGfnDACAhYdHaGeHc=';
const placeholderImage = toPlaceholderImage(thumbHashString);

const calculatedAspectRatio = 2.216083150984683;
const originalWidth = 4051;

const PracticeAnalytics = ({
  aspectRatio = calculatedAspectRatio,
  width = originalWidth,
  ...rest
}: ImageAssetProps) => (
  <ImageComponent
    aspectRatio={aspectRatio}
    width={width}
    src={optimizedImage}
    placeholderSrc={placeholderImage}
    {...rest}
  />
);

export default PracticeAnalytics;
